// import asyncRoute from '../asyncRoute';
import LogOutForced from 'Common/Components/LogOutForced/index';
import ForgotPassword from 'Screens/ForgotPassword';
import ResetPassword from 'Screens/ResetPassword';
import NotFound from '../Screens/Errores/NotFoundContainer'; // 404
import Login from '../Screens/Login/components/Login';
import Swagger from 'Screens/Swagger';
import Agents from 'Screens/Automation/Agents';
import Pipelines from 'Screens/Automation/Pipelines';
import Jobs from 'Screens/Automation/Jobs';
import Schedule from 'Screens/Automation/Schedule';
import HostsGeneral from 'Screens/Contextualization/HostsGeneral';
import VulnsGeneral from 'Screens/Contextualization/VulnsGeneral';
import ServicesGeneral from 'Screens/Contextualization/ServicesGeneral';
import WorkspaceContext from 'Screens/Contextualization/Workspaces';
import KnowledgeBaseContext from 'Screens/Contextualization/KnowledgeBase/components';
import ManageContext from 'Screens/Contextualization/Manage';
import HostContext from 'Screens/Contextualization/Host';
import Dashboard from 'Screens/Contextualization/Dashboard/components/Dashboard/index';
import Services from 'Screens/Contextualization/Services';
import HostVulnerabilities from 'Screens/Contextualization/Host/components/HostVulnerabilities';
import HostServices from 'Screens/Contextualization/Host/components/HostServices';
import Credentials from 'Screens/Credentials';

const ApplicationRoutes = {
  Routes: [
    {
      path: '/automation/agents', exact: true, component: Agents, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/automation/schedule', exact: true, component: Schedule, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/login', exact: true, component: Login, isPrivate: false
    },
    {
      path: '/forgotpass', exact: true, component: ForgotPassword, isPrivate: false
    },
    {
      path: '/resetpass/:hash', exact: true, component: ResetPassword, isPrivate: false
    },
    {
      path: '/', exact: true, component: WorkspaceContext, isPrivate: true
    },
    {
      path: '/knowledge_base/:id?', exact: false, component: KnowledgeBaseContext, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/manage/:ws/:id?', exact: false, component: ManageContext, isPrivate: true, requireWorkspace: true
    },
    {
      path: '/host/:ws/:id?', exact: true, component: HostContext, isPrivate: true, requireWorkspace: true
    },
    {
      path: '/feed/:ws', exact: true, component: Dashboard, isPrivate: true, requireWorkspace: true, edit: false
    },
    {
      path: '/api-definitions', exact: true, component: Swagger, isPrivate: true, requireWorkspace: false, edit: false
    },
    {
      path: '/logout', exact: true, component: LogOutForced, isPrivate: true, requireWorkspace: false, edit: false
    },
    {
      path: '/404', exact: true, component: NotFound, isPrivate: false, requireWorkspace: false, edit: false
    },
    {
      path: '/automation/pipelines/new', exact: true, component: Pipelines, isPrivate: true, requireWorkspace: false, isNew: true
    },
    {
      path: '/automation/pipelines/:id?', exact: true, component: Pipelines, isPrivate: true, requireWorkspace: false, edit: false, isNew: false
    },
    {
      path: '/automation/jobs/new', exact: true, component: Jobs, isPrivate: true, requireWorkspace: false, isNew: true
    },
    {
      path: '/automation/jobs/new', exact: true, component: Jobs, isPrivate: true, requireWorkspace: false, isNew: true
    },
    {
      path: '/automation/jobs/:id?', exact: true, component: Jobs, isPrivate: true, requireWorkspace: false, isNew: false
    },
    {
      path: '/service/:ws/:id?', exact: false, component: Services, isPrivate: true, requireWorkspace: true
    },
    {
      path: '/workspaces/:wsname?', exact: false, component: WorkspaceContext, isPrivate: true
    },
    {
      path: '/host/:ws/:id?/vulns/:vulnId?', exact: true, component: HostVulnerabilities, isPrivate: true, requireWorkspace: true
    },
    {
      path: '/host/:ws/:id?/services/:serviceId?', exact: true, component: HostServices, isPrivate: true, requireWorkspace: true
    },
    {
      path: '/hosts/:id?', exact: false, component: HostsGeneral, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/vulnerabilities/:id?', exact: false, component: VulnsGeneral, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/services/:id?', exact: false, component: ServicesGeneral, isPrivate: true, requireWorkspace: false
    },
    {
      path: '/credentials/:ws/:id?', exact: false, component: Credentials, isPrivate: true
    },
    { component: NotFound }
  ]
};

export default ApplicationRoutes;
